import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import trainingModuleService from "services/trainingModuleService"
import { removeTrainingModule } from "slices/trainingModuleSlice"
import { hiabColors } from "theme"
import type { ITrainingModule } from "types/trainingModuleTypes"

type Props = {
  trainingModule: ITrainingModule
}

export function DeleteTrainingModuleDialog({ trainingModule }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickDeleteApp = () => {
    setIsLoading(true)

    trainingModuleService
      .deleteTrainingModule(trainingModule.id)
      .then((_resp) => {
        dispatch(removeTrainingModule(trainingModule))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{`Delete ${trainingModule.name}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete ${trainingModule.name} training module?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              onClick={handleClickDeleteApp}
              disabled={isLoading}
              variant="contained"
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
